/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";
import { TagIssue, TagIssueFromJSON, TagIssueFromJSONTyped, TagIssueToJSON } from "./TagIssue";

/**
 *
 * @export
 * @interface TagIssueControllerResponse
 */
export interface TagIssueControllerResponse {
  /**
   *
   * @type {TagIssue}
   * @memberof TagIssueControllerResponse
   */
  data?: TagIssue;
  /**
   *
   * @type {ErrorResponse}
   * @memberof TagIssueControllerResponse
   */
  error?: ErrorResponse;
}

export function TagIssueControllerResponseFromJSON(json: any): TagIssueControllerResponse {
  return TagIssueControllerResponseFromJSONTyped(json, false);
}

export function TagIssueControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TagIssueControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : TagIssueFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function TagIssueControllerResponseToJSON(value?: TagIssueControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: TagIssueToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
